import { useLayoutEffect } from 'react'

export const useWindowSize = () => {

  let pendingUpdate = false

  const rafCallback = () => {
    pendingUpdate = false;
    //console.log('viewport =', window.visualViewport);
    //console.log('viewport.height =', window.visualViewport.height);
    const html = document.querySelector('html');
    //console.log('html =', html);
    let new_height = window.visualViewport.height;
    html.style.height = `${new_height}px`;
    html.scrollTop = 0;
    //console.log('html.height =', html.offsetHeight);
  }

  const viewportHandler = (e, delay=750) => {
    //console.log('[viewportHandler]', e);
    if (pendingUpdate) return;
    pendingUpdate = true;

    setTimeout(() => {
      //console.log('setTimeout update');
      requestAnimationFrame(rafCallback);
    }, 0.5*delay);
    setTimeout(() => {
      //console.log('setTimeout update');
      requestAnimationFrame(rafCallback);
    }, delay);
    requestAnimationFrame(rafCallback);
  }

  useLayoutEffect(() => {
    //console.log('[useWindowSize] addListener')
    window.addEventListener('resize', viewportHandler)
    window.addEventListener('scroll', viewportHandler)
    return () => {
      //console.log('[useWindowSize] removeListener')
      window.removeEventListener('resize', viewportHandler)
      window.removeEventListener('scroll', viewportHandler)
    }
  })
  return { viewportHandler }
}
